import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { IconComponent } from '@examdojo/core/icon';
import type { ReactionGroup } from '../../../../model/reaction.model';
import { ReactionGroupEditorComponent } from './reaction-group-editor.component';

@Component({
  selector: 'dojo-reaction-list-editor',
  standalone: true,
  imports: [MatExpansionModule, IconComponent, ReactionGroupEditorComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <mat-accordion class="custom-mat-accordion" [multi]="true">
      @for (group of reactions(); track $index) {
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title class="flex items-center gap-2 text-sm">
              <span class="font-medium">Reaction {{ $index + 1 }}</span>
              <span class="rounded bg-neutral-100 px-1.5 py-px text-[10px] text-neutral-400">
                {{ group.match.length }} {{ group.match.length === 1 ? 'branch' : 'branches' }}
              </span>
            </mat-panel-title>
            <mat-panel-description class="!mr-0 !flex-grow-0">
              <dojo-icon
                icon="trash"
                [size]="12"
                class="cursor-pointer text-sky-400 hover:text-sky-600"
                (click)="onGroupRemove($index); $event.stopPropagation()"
              />
            </mat-panel-description>
          </mat-expansion-panel-header>

          <div class="p-4">
            <dojo-reaction-group-editor
              [reactionGroup]="group"
              [elementIds]="elementIds()"
              (reactionGroupChange)="onGroupChange($index, $event)"
            />
          </div>
        </mat-expansion-panel>
      }
    </mat-accordion>
  `,
})
export class ReactionListEditorComponent {
  readonly reactions = input<ReactionGroup[]>([]);
  readonly elementIds = input<string[]>([]);
  readonly reactionsChange = output<ReactionGroup[]>();

  onGroupChange(index: number, group: ReactionGroup): void {
    const groups = [...(this.reactions() ?? [])];
    groups[index] = group;
    this.reactionsChange.emit(groups);
  }

  onGroupRemove(index: number): void {
    const groups = [...(this.reactions() ?? [])];
    groups.splice(index, 1);
    this.reactionsChange.emit(groups);
  }

  onAddGroup(): void {
    const groups = [...(this.reactions() ?? [])];
    groups.push({
      match: [{ when: '', dispatch: { action: 'PATCH_DISPLAY', payload: {} } }],
    });
    this.reactionsChange.emit(groups);
  }
}
